import { ReactComponent as PlaySvg } from '../../../../../assets/svg/play.svg';
import { ReactComponent as PauseSvg } from '../../../../../assets/svg/pause.svg';
import { ReactComponent as NextSvg } from '../../../../../assets/svg/next.svg';
import { ReactComponent as CheckSvg } from '../../../../../assets/svg/check.svg';
import { TIMER_STATUS, EXERCISE_MODE } from '../../../../../types/enum';

const getBorderColor = (status, pausedAt) => {
  if (status === 'READY') {
    return '#ffff00';
  }
  if (status === TIMER_STATUS.PREP) {
    return '#ffff00';
  }
  if (status === TIMER_STATUS.EXERCISE) {
    return '#00ff00';
  }
  if (status === TIMER_STATUS.REST) {
    return '#ff0000';
  }
  if (status === TIMER_STATUS.SET_REST) {
    return 'orange';
  }
  if (status === TIMER_STATUS.CYCLE_REST) {
    return '#0000ff';
  }
  if (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.PREP) {
    return '#ffff00';
  }
  if (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.EXERCISE) {
    return '#00ff00';
  }
  if (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.REST) {
    return '#ff0000';
  }
  if (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.SET_REST) {
    return 'orange';
  }
  if (status === TIMER_STATUS.PAUSE && pausedAt === TIMER_STATUS.CYCLE_REST) {
    return '#0000ff';
  }
  return '#fff';
};

const Controller = ({
  handlePrev,
  status,
  pausedAt,
  handleRepsCheck,
  isPlaying,
  handlePlay,
  handleNext,
  currentExercise,
}) => {
  return (
    <div className='flex items-center justify-evenly h-1/6'>
      <div className='border rounded-full p-3'>
        <NextSvg
          className='rotate-180'
          onClick={handlePrev}
        />
      </div>
      {currentExercise?.mode === EXERCISE_MODE.REPS &&
      status === TIMER_STATUS.EXERCISE ? (
        <button
          className={`rounded-full bg-black px-14 py-4 flex justify-center items-center text-white border-[8px] border-[#00ff00]`}
          onClick={handleRepsCheck}
        >
          <CheckSvg className='size-12' />
        </button>
      ) : (
        <button
          className={`rounded-full bg-black px-14 py-4 flex justify-center items-center text-white border-[8px] ${
            !isPlaying && 'animate-pulse'
          }`}
          style={{ borderColor: getBorderColor(status, pausedAt) }}
          onClick={handlePlay}
          disabled={status === TIMER_STATUS.DONE}
        >
          {isPlaying ? (
            <PauseSvg className='size-12' />
          ) : (
            <PlaySvg className='size-12' />
          )}
        </button>
      )}
      <div className='border rounded-full p-3'>
        <NextSvg onClick={handleNext} />
      </div>
    </div>
  );
};

export default Controller;
